const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20blockbuster%20cinematic%20scene%20with%20futuristic%20city%20and%20dramatic%20lighting%2C%20massive%20scale%20and%20grand%20visuals%2C%20professional%20film%20cinematography%2C%20dark%20moody%20atmosphere%20with%20warm%20highlights%2C%20no%20text%20or%20people&width=800&height=450&seq=media-01-6080&orientation=landscape',
    tag: '即将上映',
    title: '《星际迷航：新纪元》先导预告',
    desc: '史诗级科幻巨制，今秋震撼来袭，先睹为快。',
    duration: '2:18',
    views: '892万次观看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20cinematic%20scene%20with%20ancient%20architecture%20and%20dramatic%20golden%20hour%20lighting%2C%20epic%20scale%20and%20grand%20visuals%2C%20professional%20cinematography%2C%20warm%20amber%20tones%2C%20no%20text%20or%20people&width=800&height=450&seq=media-02-6080&orientation=landscape',
    tag: '新季上线',
    title: '《长安十二时辰》第二季预告',
    desc: '原班人马回归，全新故事篇章，高清全集不卡顿。',
    duration: '1:45',
    views: '1560万次观看',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20film%20cinematic%20scene%20with%20magical%20creatures%20and%20dreamy%20atmosphere%2C%20vibrant%20colors%20with%20golden%20light%20particles%2C%20high%20quality%20animation%20visuals%2C%20cinematic%20framing%2C%20no%20text%20or%20people&width=800&height=450&seq=media-03-6080&orientation=landscape',
    tag: '独家放送',
    title: '《风之谷2》幕后特辑独家',
    desc: '宫崎骏工作室最新力作幕后揭秘，全球首发。',
    duration: '5:32',
    views: '678万次观看',
  },
];

const rankingItems = [
  { rank: 1, title: '星际穿越2', type: '科幻', heat: '本周最热', change: 'up' },
  { rank: 2, title: '长安十二时辰第二季', type: '国产剧', heat: '1560万播放', change: 'up' },
  { rank: 3, title: '反恐行动', type: '动作', heat: '1280万播放', change: 'new' },
  { rank: 4, title: '信号3', type: '韩剧', heat: '1090万播放', change: 'up' },
  { rank: 5, title: '黑暗荣耀', type: '韩剧', heat: '980万播放', change: 'down' },
];

export default function MediaRankingSection() {
  return (
    <>
      <section id="media" className="relative w-full py-16 md:py-20 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              精彩预告
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              最新预告片与独家内容，抢先了解即将上线的影视大作
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {mediaItems.map((item, idx) => (
              <div
                key={idx}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden">
                  <img
                    src={item.image}
                    alt={`6080新视觉影院 ${item.tag} - ${item.title}`}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/80 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-xl md:text-2xl text-foreground-950 ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-3 right-3">
                    <span className="px-2 py-0.5 text-[10px] bg-background-50/80 backdrop-blur-sm text-foreground-500 rounded-full">
                      {item.duration}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <span className="text-[10px] font-medium text-accent-400 bg-accent-500/10 px-2 py-0.5 rounded-full whitespace-nowrap mb-2 inline-block">
                    {item.tag}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-800 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed mb-2">
                    {item.desc}
                  </p>
                  <span className="text-xs text-foreground-400">{item.views}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="ranking" className="relative w-full py-16 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              实时更新的高清电影电视剧热度排行，看看大家都在看什么
            </p>
          </div>
          <div className="space-y-2">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-4 bg-background-100 rounded-lg p-4 border border-background-200/40 hover:border-primary-500/10 transition-all duration-200 cursor-pointer"
              >
                <span className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold font-heading whitespace-nowrap ${
                  item.rank === 1 ? 'bg-primary-500 text-foreground-950' :
                  item.rank === 2 ? 'bg-primary-500/30 text-primary-400' :
                  item.rank === 3 ? 'bg-accent-500/30 text-accent-400' :
                  'bg-background-200/60 text-foreground-500'
                }`}>
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-800 truncate">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-500/10 text-secondary-400 rounded-full whitespace-nowrap flex-shrink-0">
                      {item.type}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat}</span>
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${
                      item.change === 'up' ? 'ri-arrow-up-line text-primary-400' :
                      item.change === 'down' ? 'ri-arrow-down-line text-foreground-400' :
                      'ri-add-line text-accent-400'
                    } text-sm`}></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}